import React from 'react'
import { TopNavBar, NavBar, Footer } from './components'
import { Home, Courses, Partners, Register, ContactUs, About, NotFound } from './containers'
import { Route, Routes } from 'react-router-dom'

const App = () => {
  return (
    <section className={`h-full w-full font-poppins flex flex-col flex-1`}>
      <TopNavBar />
      <NavBar />

      <Routes>
        <Route path='/' element={<Home/>} exact/>
        <Route path='/about' element={<About/>} exact/>
        <Route path='/partners' element={<Partners/>} exact/>
        <Route path='/contactUs' element={<ContactUs/>} exact/>
        <Route path='/register' element={<Register/>} exact/>
        <Route path='/courses' element={<Courses/>} exact/>
        <Route path='/*' element={<NotFound/>} />
      </Routes>

      <div>
        <Footer />
      </div> 
      
    </section>
  )
}

export default App
